export default __webpack_public_path__ + "static/media/reporthelp-form-mobile.95fbec8f.PNG";